import { isNil } from 'ramda';
import {
  isMarketplaceAuction,
  isMarketplaceDraw,
} from '~admin/view/components/details/helper/marketplace.helper';
import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';
import { datetime } from '~common/helper/datetime';

/**
 * Transforms MarketplaceFormData to Partial<MarketplaceRequest>
 * @param marketplaceFormData
 */
export const getMarketplaceDatetimeDetailsRequest = (
  marketplaceFormData: MarketplaceFormData,
): Pick<
  MarketplaceRequest,
  | 'startDateTime'
  | 'endDateTime'
  | 'minManualPaymentDurationSeconds'
  | 'maxManualPaymentDurationSeconds'
  | 'endCalculateWinnersDate'
  | 'forceAllocationDate'
> => {
  const {
    type,
    startDateTime,
    endDateTime,
    minManualPaymentDurationMinutes,
    maxManualPaymentDurationMinutes,
    timeToForceAllYoopAllocation,
    timeToStartPickingSeats,
    timeToForAllSeatAllocation,
  } = marketplaceFormData;

  // TODO(Dmitry): Talk to backend about changing this, it doesn't make sense to have endCalculateWinnersDate for PURCHASE
  let endCalculateWinnersDate = datetime.parse(endDateTime).add(15, 'minute').toISOString();
  let forceAllocationDate: string = null;

  if (isMarketplaceDraw(type)) {
    endCalculateWinnersDate = forceAllocationDate = datetime
      .parse(timeToForceAllYoopAllocation)
      ?.toISOString();
  } else if (isMarketplaceAuction(type)) {
    endCalculateWinnersDate = datetime.parse(timeToStartPickingSeats)?.toISOString();
    forceAllocationDate = datetime.parse(timeToForAllSeatAllocation)?.toISOString();
  }

  return {
    startDateTime: datetime.parse(startDateTime).toISOString(),
    endDateTime: datetime.parse(endDateTime).toISOString(),
    minManualPaymentDurationSeconds: !isNil(minManualPaymentDurationMinutes)
      ? minManualPaymentDurationMinutes * 60
      : null,
    maxManualPaymentDurationSeconds: !isNil(maxManualPaymentDurationMinutes)
      ? maxManualPaymentDurationMinutes * 60
      : null,
    endCalculateWinnersDate,
    forceAllocationDate,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/marketplace-request/marketplace-datetime-details-request.helper.ts